import { useState, useContext } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import undrawProfile from "../img/undraw_profile.svg";
import serviceIcon from "../img/service.png";
import profileBackground from "../img/profile-bg.png";
import Settings from "./Settings";
import SpaceMenu from "./SpaceMenu";
import { useSelector } from "react-redux";
import {
  concatenateAndTruncate,
  truncateText,
} from "../../utils/application-helper";
import VideoComponent from "./VideoComponent";
import { AuthContext } from "../contexts/AuthContext";

const UserMenu = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useSelector((state) => state.user);
  const { user } = useContext(AuthContext);
  const userId = user?.userId || user?.data?.data?.userId;
  const userName = user?.userName || user?.data?.data?.userName;
  const [showProfile, setShowProfile] = useState(props.showProfile || false);

  const navigateHandler = (name) => {
    navigate(name);
    props.toggleHandler();
  };

  const renderMedia = () => {
    if (userData?.bannerUrl === null) {
      return (
        <img
          src={profileBackground}
          alt="Default Image"
          className="img-fluid postion-absolute banner-url"
        />
      );
    }
    const fileExtension =
      userData?.bannerUrl &&
      userData?.bannerUrl.split(".").pop()?.toLowerCase();

    if (
      fileExtension === "png" ||
      fileExtension === "jpeg" ||
      fileExtension === "jpg" ||
      fileExtension === "gif"
    ) {
      return (
        <img
          src={userData.bannerUrl}
          alt="User Banner"
          className="img-fluid postion-absolute banner-url"
        />
      );
    } else if (!fileExtension) {
      return (
        <img
          src={userData?.bannerUrl}
          alt="Default Image"
          className="img-fluid postion-absolute banner-url"
        />
      );
    } else {
      return <VideoComponent userData={userData} isUserMenu={true} />;
    }
  };

  return (
    <div className={props.isMenu ? "dropdown-menu user-menu pt-0" : ""}>
      {showProfile &&
        // <img
        //   src={userData?.bannerUrl ? userData?.bannerUrl : profileBackground}
        //   className="img-fluid postion-absolute banner-url"
        // />
        renderMedia()}
      <div className="card-body p-0">
        {showProfile && (
          <div onClick={() => navigateHandler(`/${userName}`)}>
            <div className="d-flex">
              <div className="sme-profile">
                <img
                  className={`img-profile rounded-circle ml-1 ${
                    userData?.offerService ? "sme-mini-service" : null
                  }`}
                  src={userData?.picUrl ? userData?.picUrl : undrawProfile}
                />
                {userData?.offerService && (
                  <div className="sme-mini-icon" style={{ bottom: "20px" }}>
                    SME
                  </div>
                )}
              </div>
              <div>
                <p className="profile-name mb-0 ml-3 mt-1">
                  {`${userData?.fName || ""} ${userData?.lName || ""}`}
                </p>
                <p className="ml-3">{`${
                  userData?.experiences
                    ? truncateText(userData.experiences, 30)
                    : ""
                }`}</p>
              </div>
            </div>
          </div>
        )}

        <div className="d-flex w-100 align-items-center justify-content-between pl-3">
          <div>
            {props.showSettings && (
              <div className="mt-3 bg-white side-menu">
                <Settings />
              </div>
            )}
          </div>
        </div>

        {props.spaceMenu && (
          <SpaceMenu
            name={
              (userName &&
                location.pathname.trim().split("/")[1] == userName &&
                "myspace") ||
              (props.path.includes("myspace") && "myspace") ||
              (props.path.includes("my-posts") && "myspace") ||
              (userName &&
                location.pathname.trim().split("/")[1] != userName &&
                "user")
            }
            planType={userData?.subscription?.main_plan_name}
            otherUserId={props?.otherUser?.userId}
            otherUserPlanType={props?.otherUser?.subscription?.main_plan_name}
          />
        )}

        {showProfile && (
          <div className="bg-white card-body">
            <Settings
              navigateHandler={navigateHandler}
              toggleHandler={props.toggleHandler}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default UserMenu;
